import React from "react";
import { IconProps } from ".";

const RefreshIcon: React.FC<IconProps> = ({
  size = "16",
  color = "currentColor",
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8 0.5C4.68667 0.5 2 3.18667 2 6.5H0L2.66667 9.16667L5.33333 6.5H3.33333C3.33333 3.92 5.42 1.83333 8 1.83333C10.58 1.83333 12.6667 3.92 12.6667 6.5C12.6667 9.08 10.58 11.1667 8 11.1667C6.99333 11.1667 6.06 10.84 5.29333 10.3L4.34667 11.26C5.36 12.0333 6.62667 12.5 8 12.5C11.3133 12.5 14 9.81333 14 6.5C14 3.18667 11.3133 0.5 8 0.5Z"
        fill={color}
      />
    </svg>
  );
};

export default RefreshIcon;
